import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="payment-cancel">
      <div className="w-16 h-16 rounded-full bg-[#FDE74C]/40 text-[#7A5F00] grid place-items-center mx-auto"><XCircle className="w-8 h-8" /></div>
      <h1 className="mt-6 font-display font-black text-3xl">Checkout cancelled</h1>
      <p className="mt-4 text-[#7A7D8C]">Your spot isn't reserved yet. Head back to registration when you're ready.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/register" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#FF9F1C] text-white font-bold shadow-[0_12px_30px_rgb(255,159,28,0.35)]">Back to registration <ArrowRight className="w-4 h-4" /></Link>
        <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-slate-200 font-bold">Home</Link>
      </div>
    </div>
  );
}
